import React, { useRef, useEffect, useState, useCallback, useMemo, useContext } from 'react';
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { CircularProgress, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import SnakeEventManager from '../components/slideshow/SnakeChart';
import breakImage2 from '../images/2026/2.png';
import breakImage3 from '../images/2026/3.png';
import breakImage4 from '../images/2026/4.png';
import breakImage5 from '../images/2026/5.png';
import breakImage6 from '../images/2026/6.png';
import breakImage7 from '../images/2026/7.png';
import breakImage8 from '../images/2026/8.png';
import newGeneralGraphic2024 from '../images/2026/stage.png';
import { UserDataContext } from '../firebase/UserDataContext';
import { FirebaseNewContext } from '../firebase/FirebaseNewContext';
import CompetitionDropdown from '../components/forms/Dropdowns/CompetitionDropdown';
import AsyncImage from '../components/misc/AsyncImage';
import PresentationMusicAdmin from '../components/misc/PresentationMusicAdmin';
import { ROLES } from '../components/misc/Utils';
import beepSound from '../assets/sounds/beep.mp3';
import blipSound from '../assets/sounds/blip.mp3';
import coffeeBreakMusic from '../assets/sounds/coffee-break-music.mp3';
import LocalMusicPlayer from './LocalMusicPlayer';

const theme = createTheme({
    palette: {
        primary: {
            main: '#00ff00', // Green
        },
        warning: {
            main: '#ffeb3b', // Yellow
        },
        secondary: {
            main: '#ff5722', // Orange
        },
        error: {
            main: '#f44336', // Red
        },
    },
});

function VisualTimer({ minutes, suffix, onFinished, restartKey, whereAreWe, item, playMusic }) {
    const [timeLeft, setTimeLeft] = useState(minutes * 60);
    const [finished, setFinished] = useState(false);
    const intervalRef = useRef(null);
    const beepIntervalRef = useRef(null);
    const breakMusicRef = useRef(new Audio(coffeeBreakMusic));
    const beepAudioRef = useRef(new Audio(beepSound));
    const blipAudioRef = useRef(new Audio(blipSound));
    const onBreak = ['Break', 'Lunch'].includes(whereAreWe);
    let additionalStylesContainer = {}
    let additionalTimerRingSize = undefined
    switch (item.image) {
        case "Sponsors-Pratt.jpg":
        case "Sponsors-American.jpg":
        case "Sponsors-Snap-on.jpg":
            additionalStylesContainer = {
                marginTop: '35em'
            }
            additionalTimerRingSize = 300
            break;
        case "Sponsors-All.jpg":
            additionalStylesContainer = {
                marginTop: '35em',
                right: '-4em'
            }
            additionalTimerRingSize = 300
            break;
        case "Main-Half.jpg":
            break;
    }


    breakMusicRef.current.loop = true;

    const progress = (timeLeft / (minutes * 60)) * 100;
    const baseTimerSize = additionalTimerRingSize ? additionalTimerRingSize : 600;
    const timerSize = onBreak ? 320 : baseTimerSize;

    // ⏲️ Timer countdown logic (only once)
    useEffect(() => {
        if (intervalRef.current) clearInterval(intervalRef.current);

        intervalRef.current = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;

                    console.log("finished");

                    // if (!finished) {
                    blipAudioRef.current.play();
                    setFinished(true);
                    console.log("Finished!!!!!!!!!!!!!!!!!!!!!1");
                    onFinished();
                    // }

                    // stop beeps if still going
                    if (beepIntervalRef.current) {
                        clearInterval(beepIntervalRef.current);
                        beepIntervalRef.current = null;
                    }

                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(intervalRef.current);
    }, [restartKey, minutes]); // Only when minutes or restartKey changes

    // Beep alerts during last 20 seconds
    useEffect(() => {
        if (timeLeft <= 11 && timeLeft > 1) {
            if (!beepIntervalRef.current) {
                beepIntervalRef.current = setInterval(() => {
                    beepAudioRef.current.play();
                }, 1000);
            }
        } else {
            if (beepIntervalRef.current) {
                clearInterval(beepIntervalRef.current);
                beepIntervalRef.current = null;
            }
        }
    }, [timeLeft]);

    // Handle break music
    useEffect(() => {
        if (onBreak) {
            //breakMusicRef.current.play().catch(err => console.warn("Break music failed to play:", err));
        } else {
            breakMusicRef.current.pause();
            breakMusicRef.current.currentTime = 0;
        }

        return () => {
            breakMusicRef.current.pause();
            breakMusicRef.current.currentTime = 0;
        };
    }, [onBreak]);

    // Reset timer on props change
    useEffect(() => {
        setTimeLeft(minutes * 60);
        setFinished(false);
    }, [minutes, restartKey]);

    // Full cleanup on unmount
    useEffect(() => {
        return () => {
            clearInterval(intervalRef.current);
            clearInterval(beepIntervalRef.current);
            breakMusicRef.current.pause();
            breakMusicRef.current.currentTime = 0;
            beepAudioRef.current.pause();
            blipAudioRef.current.pause();
            setFinished(false);
        };
    }, []);

    const getColor = (progress) => {
        if (progress > 66) return 'primary';
        if (progress > 33) return 'warning';
        if (progress > 10) return 'secondary';
        return 'error';
    };

    return (
        <>
            {onBreak && playMusic && (
                <LocalMusicPlayer
                    play={true}
                />
            )}
            <ThemeProvider theme={theme}>
                <Grid2
                    container
                    alignItems="center"
                    justifyContent="center"
                    sx={Object.assign({
                        height: '100%',
                        width: "100vw",
                        display: "flex",
                        position: "relative"
                    }, additionalStylesContainer)}
                >
                    <Box
                        sx={{
                            position: onBreak ? 'fixed' : 'relative',
                            top: onBreak ? 'auto' : undefined,
                            bottom: onBreak ? 110 : undefined,
                            left: onBreak ? 90 : undefined,
                            width: timerSize,
                            height: timerSize,
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <CircularProgress
                            variant="determinate"
                            value={parseFloat(progress.toFixed(2))}
                            size={timerSize}
                            thickness={1.5}
                            color={getColor(progress)}
                        />
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center',
                                color: 'black'
                            }}
                        >
                            <Typography variant="h1">
                                {`${Math.floor(timeLeft / 60)}:${String(timeLeft % 60).padStart(2, '0')}`}
                            </Typography>
                            <Typography variant="h3">
                                {suffix}
                            </Typography>
                        </Box>
                    </Box>
                </Grid2>
            </ThemeProvider>
        </>
    );
}

function SlideShowTimerPage(props) {
    const [eventTimePlay, setEventTimePlay] = useState(false);
    const [playMusic, setPlayMusic] = useState(true);
    const [eventCounter, setEventCounter] = useState(0);
    const [schedule, setSchedule] = useState(null);
    const [breakGraphic, setBreakGraphic] = useState({ toShow: breakImage2, used: [] });
    const screen1 = useFullScreenHandle();
    const { firebase } = useContext(FirebaseNewContext);
    const { defaultSelectedCompetition, user } = useContext(UserDataContext);
    const [selectedCompetition, setSelectedCompetition] = useState(props.competition || defaultSelectedCompetition);

    useEffect(() => {
        const fetchSchedule = async () => {
            console.log("here");
            const fetchedSchedule = await firebase.getSchedule(selectedCompetition);
            setSchedule(fetchedSchedule != null ? fetchedSchedule : []);
        };
        fetchSchedule();
    }, [firebase, selectedCompetition]);

    const selectBreakGraphic = (graphics, graphicsUsed) => {
        console.log(graphicsUsed);
        const availableGraphics = graphics.filter((_, k) => !graphicsUsed.includes(k));
        return availableGraphics[0] || graphics[0];
    };

    const reportChange = useCallback((state, handle) => {
        if (handle === screen1 && !state) {
            setEventTimePlay(false);
        }
    }, [screen1]);

    const breakGraphics = [breakImage2, breakImage3, breakImage4, breakImage5, breakImage6, breakImage7, breakImage8];

    useEffect(() => {
        if (schedule && schedule.length > 0 && schedule[eventCounter]) {
            const currentEvent = schedule[eventCounter];
            if (['Break', 'Lunch'].includes(currentEvent.type)) {
                const selectedGraphic = selectBreakGraphic(breakGraphics, breakGraphic.used);

                let used = [];
                if (breakGraphic.used.length < breakGraphics.length - 1) {
                    used = [...breakGraphic.used, breakGraphics.indexOf(selectedGraphic)]
                }

                setBreakGraphic({
                    toShow: selectedGraphic,
                    used,
                });
            }
        }
    }, [eventCounter, schedule]);

    const current = schedule && schedule[eventCounter] ? schedule[eventCounter] : null;

    const handleSnakeEventSelection = (index) => {

        setEventCounter(index);

        screen1.enter().then(() => {
            setEventTimePlay(true);
        }).catch((error) => {
            console.error("Error entering full-screen mode:", error);
        });
    };

    const setOuterEvents = (events) => {
        setSchedule([...events]);
        // Only persist to Firebase when we have a valid competition selected
        if (selectedCompetition) {
            try {
                firebase.insertSchedule(selectedCompetition, events);
            } catch (e) {
                console.error('Failed to persist schedule:', e);
            }
        } else {
            console.warn('No selectedCompetition; skipping insertSchedule');
        }
    };

    const handleNextEvent = useCallback(() => {
        setEventCounter(prev => {
            const next = prev + 1;
            if (!schedule || next >= schedule.length) {
                screen1.exit();
                return prev;
            }
            return next;
        });
    }, [schedule, screen1]);

    if (schedule === null) {
        return <Typography variant='h5'>Loading schedule...</Typography>;
    }

    return (
        <Grid2 container direction="column" sx={{ p: { xs: 2, sm: 3 }, gap: 2, mx: 'auto', width: '100%', }}>
            <label>
                <input
                    type="checkbox"
                    checked={playMusic}
                    onChange={(event) => setPlayMusic(event.target.checked)}
                />
                Play Music
            </label>
            <Typography variant='h3' sx={{ marginBottom: "18px" }}>Competition Slideshow Timer Page</Typography>
            <CompetitionDropdown
                value={selectedCompetition}
                onChange={setSelectedCompetition}
                sx={{ marginBottom: '10px' }}
            />

            {(user && (user.role === ROLES.ADMIN || user.role === ROLES.SCORECOMMITTEE)) ? (
                <PresentationMusicAdmin />
            ) : null}

            <br />

            <SnakeEventManager
                initialEvents={schedule}
                presentEvent={handleSnakeEventSelection}
                setOuterEvents={setOuterEvents}
                competition={selectedCompetition}
            />
            <Grid2 sx={{ display: screen1.active ? "block" : "none" }}>
                <FullScreen handle={screen1} onChange={reportChange}>
                    <Grid2 container sx={{ height: '100vh' }}>
                        <Grid2 sx={{ textAlign: 'center', width: '100%' }}>
                            {eventTimePlay && current && (
                                <Grid2
                                    container
                                    sx={{
                                        backgroundImage: current.carousel
                                            ? `url(${['Break', 'Lunch'].includes(current.type) ? breakGraphic.toShow : newGeneralGraphic2024})`
                                            : undefined,
                                        backgroundPosition: 'center',
                                        backgroundColor: 'white',
                                        backgroundSize: 'cover',
                                        backgroundRepeat: 'no-repeat',
                                        width: '100%',
                                        height: '100%',
                                        alignItems: 'center',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    {!current.carousel && (
                                        <AsyncImage
                                            getImageSrc={async () => {
                                                if (current?.image === "default") {
                                                    return newGeneralGraphic2024;
                                                } else {
                                                    try {
                                                        const imageSrc = current?.image !== undefined
                                                            ? await firebase.getImage(selectedCompetition, current?.image)
                                                            : undefined;
                                                        return imageSrc || newGeneralGraphic2024;
                                                    } catch (error) {
                                                        console.error("Failed to get image:", error);
                                                        return newGeneralGraphic2024;
                                                    }
                                                }
                                            }}
                                            alt="Event Image"
                                            imageStyle={{ objectFit: 'fill', width: '100vw', height: '100vh', position: "absolute", top: current?.image === 'default' ? undefined : 0, bottom: current?.image === 'default' ? 0 : undefined, left: 0 }}
                                        />
                                    )}
                                    <Grid2 item xs={12}>
                                        <VisualTimer
                                            whereAreWe={current.type}
                                            item={current}
                                            minutes={current.duration}
                                            restartKey={eventCounter}
                                            onFinished={handleNextEvent}
                                            suffix={current.name}
                                            playMusic={playMusic}
                                        />
                                    </Grid2>
                                </Grid2>
                            )}
                        </Grid2>
                    </Grid2>
                </FullScreen>
            </Grid2>
        </Grid2>
    );
}

export default SlideShowTimerPage;
